// extracted by mini-css-extract-plugin
export var orderSummary = "_rn-0";
export var showMoreLessButton = "_rn-1";